import axios from "axios";
import { Fragment, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import _ from "lodash";
import { useAtom } from "jotai";
import { bonusStore } from "../../DataStore/atom";
import TranslatesContent from "../../DataStore/Languages/translatesContent";

let validator = {};

const SlipUpload = () => {
  const schema = yup.object().shape(validator);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [, setBonusStore] = useAtom(bonusStore);

  const [errmsg, setErrmsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loader, setLoader] = useState(false);
  const [formattedAmount, setFormattedAmount] = useState("");

  const [selectedOption, setSelectedOption] = useState(1);

  const bonusOfferSwitch = (status) => {
    setSelectedOption(status);
    setBonusStore(status);
  };

  const ValidateDepositAmount = (reAmount) => {
    const numericValue = reAmount.replace(/[^0-9.]/g, "");

    setFormattedAmount(numericValue ? formatCurrency(numericValue) : "");
    if (reAmount !== "" && Number(reAmount) < 10000) {
      setSuccessMsg(false);
      return setErrmsg(
        "Please enter an amount greater than the minimum limit."
      );
    }
    setErrmsg(false);
  };

  const formatCurrency = (value) => {
    const formattedValue = new Intl.NumberFormat("en-US", {
      currency: "USD",
    }).format(value);

    return formattedValue;
  };

  let submitHandler = async (bankPaymentObj) => {
    try {
      setLoader(true);
      setErrmsg("");
      setSuccessMsg("");
      // Use formattedAmount for the API, stripping commas
      const cleanAmount = formattedAmount.replace(/,/g, "");
      if (!cleanAmount || Number(cleanAmount) < 10000) {
        setErrmsg("Please enter a valid amount");
        setTimeout(() => setErrmsg(""), 3000);
        setLoader(false);
        return;
      }
      // API call for deposit
      const payload = {
        provider: "bank",
        bonus: selectedOption,
        fiatAmount: cleanAmount,
        currencyType: "LKR",
        bank_id: 1,
      };
      const resp = await axios.post("/api/paymentgws/deposit", payload, {
        headers: { "Content-Type": "application/json" },
      });
      if (
        resp.data &&
        (resp.data.status === true || resp.data.success === true)
      ) {
        
        if (resp.data.type === "url" && resp.data.value) {
          setSuccessMsg("Deposit request successful. Redirecting to slip upload...");
          window.location.href = resp.data.value;
          return;
        }
        setSuccessMsg(resp.data.message || "Deposit request successful.");
        reset();
        setFormattedAmount("");
      } else {
        setErrmsg(resp.data.message || "Deposit request failed.");
      }
    } catch (err) {
      setErrmsg("API Error: " + (err.response?.data?.message || err.message));
    } finally {
      setLoader(false);
    }
  };

  return (
    <div
      className="tab-pane fade show active "
      id="v-pills-profile"
      role="tabpanel"
      aria-labelledby="v-pills-profile-tab"
    >
      <div className="row">
        <form onSubmit={handleSubmit(submitHandler)}>
          <div className="row d-flex justify-content-center my-5">
            <div className="col-md-4 mb-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="cashierNewTitel"
              >
                <TranslatesContent contentKey="deposit-amount" />
              </label>
              <div className="input-group">
                <span
                  className="input-group-text"
                  style={{
                    border: "1px solid #2f2f2f",
                    fontWeight: 600,
                    backgroundColor: "#c7c7c7",
                  }}
                >
                  LKR
                </span>
                <input
                  placeholder="0"
                  type="text"
                  style={{ textAlign: "right" }}
                  className={`form-control ${
                    _.isEmpty(errors)
                      ? ""
                      : errors?.amount
                      ? "is-invalid"
                      : "is-valid"
                  }`}
                  {...register("amount")}
                  onInput={(e) => {
                    ValidateDepositAmount(e.target.value);
                  }}
                  value={formattedAmount}
                />
                <div className="col-12">
                  <div className="form-text text-center">
                    minimum limit : LKR 10,000
                  </div>
                </div>
              </div>
              {/* Bonus Activation moved here */}
              <div className="mb-3 mt-4">
                <label className="cashierNewTitel">Bonus Activation</label>
                <div className="d-flex justify-content-center">
                  <div className="px-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        style={{ padding: "0" }}
                        type="radio"
                        id="bonusYes"
                        checked={selectedOption === 1}
                        onChange={() => bonusOfferSwitch(1)}
                      />
                      <label
                        className="form-check-label mt-1 ms-2"
                        htmlFor="bonusYes"
                      >
                        Yes
                      </label>
                    </div>
                  </div>
                  <div className="px-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        style={{ padding: "0" }}
                        type="radio"
                        id="bonusNo"
                        checked={selectedOption === 0}
                        onChange={() => bonusOfferSwitch(0)}
                      />
                      <label
                        className="form-check-label mt-1 ms-2"
                        htmlFor="bonusNo"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-center">
            <div className="col-md-6 mb-3">
              {errors?.amount?.message ? (
                <div className="invalid-feedback">
                  {errors?.amount?.message}
                </div>
              ) : null}
              {successMsg && (
                <div
                  style={{ marginTop: "30px" }}
                  className="alert alert-success"
                >
                  {successMsg}
                </div>
              )}
              {errmsg && (
                <div
                  style={{ marginTop: "30px" }}
                  className="alert alert-danger"
                >
                  {errmsg}
                </div>
              )}
            </div>
          </div>
          <div className="row d-flex justify-content-center my-5">
            <div className="col-md-4 mb-3">
              <button type="submit" className="btn btn-primary btn-lg w-100">
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    confirming...
                  </>
                ) : (
                  "CONFIRM"
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SlipUpload;